import React, {useEffect, useState} from 'react';
import { MapContainer, Marker, AttributionControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import SaarlandOverlay from "../mainpage/map/SaarlandOverlay";
import companyMarkerIcon from "../mainpage/map/companyMarkerIcon";
import { Snackbar, Alert } from '@mui/material';
import {useTranslation} from "react-i18next";
import MapTileLayers from "../mainpage/map/MapTileLayers";

function LocationMarker({ latitude, longitude }) {
  const [position, setPosition] = useState(
    latitude && longitude ? [latitude, longitude] : null
  );

  useEffect(() => {
    if (latitude && longitude) {
      setPosition([latitude, longitude]);
    }

  }, [latitude, longitude]);

  return position ? <Marker icon={companyMarkerIcon} position={position} /> : null;
}

export default function CoordinatePickerMap({ latitude, longitude, showSaarlandBorderAlert }) {
  const [saarlandGeoJson, setSaarlandGeoJson] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    fetch('/data/Saarland.geojson')
      .then((res) => res.json())
      .then(setSaarlandGeoJson);
  }, []);

  return (
    <div style={{ height: '350px', marginBottom: '1rem' }}>
      <MapContainer
        center={[latitude || 49.2347706, longitude || 6.979751]}
        zoom={12}
        minZoom={10}
        style={{ height: '100%', width: '100%' }}
        attributionControl={false}
      >
        <AttributionControl position="bottomright" prefix="Leaflet" />
        {saarlandGeoJson && <SaarlandOverlay geoJson={saarlandGeoJson} />}
        <MapTileLayers />
        <LocationMarker
          latitude={latitude}
          longitude={longitude}
        />
      </MapContainer>
      <Snackbar
        open={showSaarlandBorderAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="warning" sx={{ width: '100%' }}>
          {t('company_form.saarlandwarning')}
        </Alert>
      </Snackbar>
    </div>
  );
}
